import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "eyeOpened"
const EyeOpenedIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 6.75C14.485 6.75 16.5 8.765 16.5 11.25S14.485 15.75 12 15.75 7.5 13.735 7.5 11.25 9.515 6.75 12 6.75M12 8.25C10.343 8.25 9 9.593 9 11.25S10.343 14.25 12 14.25 15 12.907 15 11.25 13.657 8.25 12 8.25"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M12 3.75C18.75 3.75 22.5 11.25 22.5 11.25S18.75 18.75 12 18.75 1.5 11.25 1.5 11.25 5.25 3.75 12 3.75M12 5.25C9.211 5.25 6.953 6.8 5.306 8.533 4.494 9.388 3.87 10.248 3.45 10.896Q3.325 11.087 3.226 11.25 3.326 11.413 3.45 11.604C3.869 12.253 4.494 13.113 5.306 13.968 6.953 15.7 9.211 17.25 12 17.25S17.047 15.7 18.694 13.967C19.506 13.112 20.13 12.252 20.55 11.604Q20.675 11.414 20.773 11.25 20.674 11.087 20.55 10.896C20.131 10.248 19.506 9.388 18.694 8.533 17.047 6.8 14.789 5.25 12 5.25"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default EyeOpenedIcon
